import { ValidationResult } from './validateGraph';

export function areValidationsValid(validationResult: ValidationResult): boolean {
    return validationResult.connectionValidations.every(connectionValidation => connectionValidation.valid);
}
